package com.partejar.app.feature.relacionamentos.presentation

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Icon
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.partejar.app.core.ui.components.PartejarAlert
import com.partejar.app.core.ui.components.PartejarAlertTone
import com.partejar.app.core.ui.components.PartejarIconButton
import com.partejar.app.core.ui.components.PartejarTopBar
import com.partejar.app.core.ui.theme.PartejarIcons
import com.partejar.app.core.ui.theme.PartejarTheme
import com.partejar.app.feature.relacionamentos.data.RelacionamentoStage
import org.koin.compose.koinInject

@Composable
internal fun RelacionamentoEditScreen(
    id: Long,
    onBack: () -> Unit,
    onSaved: () -> Unit,
    viewModel: RelacionamentoDetailViewModel = koinInject()
) {
    val detail by viewModel.detail.collectAsState()
    val error by viewModel.error.collectAsState()
    val busyAction by viewModel.busyAction.collectAsState()
    LaunchedEffect(id) { viewModel.load(id) }
    LaunchedEffect(viewModel) {
        viewModel.completedAction.collect { action ->
            if (action == RelationshipDetailAction.UPDATE) onSaved()
        }
    }

    Scaffold(topBar = {
        PartejarTopBar(
            title = if (detail?.stage == RelacionamentoStage.LOST) "Dados do relacionamento" else "Editar dados",
            leadingContent = {
                PartejarIconButton(onClick = onBack) {
                    Icon(PartejarIcons.Actions.back, contentDescription = "Voltar")
                }
            }
        )
    }) { padding ->
        Column(
            modifier = Modifier.fillMaxSize()
                .padding(padding)
                .imePadding()
                .windowInsetsPadding(WindowInsets.safeDrawing.only(WindowInsetsSides.Bottom))
                .verticalScroll(rememberScrollState())
                .padding(PartejarTheme.spacing.space16)
        ) {
            error?.let { PartejarAlert("Não foi possível salvar", PartejarAlertTone.ERROR) { Text(it) } }
            detail?.let { item ->
                RelationshipEditForm(
                    item = item,
                    editing = item.stage != RelacionamentoStage.LOST,
                    readOnly = item.stage == RelacionamentoStage.LOST,
                    submitting = busyAction == RelationshipDetailAction.UPDATE,
                    contractAttempt = 0,
                    onEditingChange = { onBack() },
                    onSave = { viewModel.update(id, it) }
                )
            }
        }
    }
}
